import React, { useState } from 'react';
import { usePWAInstall } from '../hooks/usePWAInstall';
import PWAInstallModal from './PWAInstallModal';

/**
 * Banner para promover la instalación de la PWA
 * Se muestra en la parte superior de la página
 * Se oculta automáticamente si la app ya está instalada
 */
const PWAInstallBanner = () => {
  const { isInstalled, isInstallable, isIOS, isAndroid, canInstall, promptInstall } = usePWAInstall();
  const [showModal, setShowModal] = useState(false);

  // Verificar si el usuario cerró el banner anteriormente
  const bannerDismissed = localStorage.getItem('pwa_banner_dismissed') === 'true';

  // No mostrar el banner si la app ya está instalada o si fue cerrado
  if (isInstalled || bannerDismissed) {
    return null;
  }

  // No mostrar si no se puede instalar
  if (!canInstall) {
    return null;
  }

  const handleBannerClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleInstall = async () => {
    const result = await promptInstall();
    if (result.success) {
      handleCloseModal();
    }
  };

  return (
    <>
      <div className="bg-gradient-to-r from-green-500 to-green-600 text-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3 flex-1">
              {/* Imagen del teléfono - El usuario proveerá esta imagen */}
              <div className="flex-shrink-0">
                <img
                  src="/images/phone-hand.png"
                  alt="Descargar App"
                  className="h-10 w-10 object-contain"
                  onError={(e) => {
                    // Fallback si la imagen no existe
                    e.target.style.display = 'none';
                  }}
                />
              </div>
              
              {/* Texto del banner */}
              <div className="flex-1">
                <button
                  onClick={handleBannerClick}
                  className="text-left hover:opacity-90 transition-opacity"
                >
                  <p className="font-semibold text-sm sm:text-base">
                    Descargar App
                  </p>
                  <p className="text-xs sm:text-sm opacity-90">
                    Instala Alquilalo! en tu dispositivo
                  </p>
                </button>
              </div>
            </div>

            {/* Botón de cerrar */}
            <button
              onClick={() => {
                // Guardar en localStorage que el usuario cerró el banner
                localStorage.setItem('pwa_banner_dismissed', 'true');
                // Recargar para ocultar el banner
                window.location.reload();
              }}
              className="ml-4 flex-shrink-0 text-white hover:text-gray-200 transition-colors"
              aria-label="Cerrar banner"
            >
              <svg
                className="h-5 w-5"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Modal con instrucciones de instalación */}
      {showModal && (
        <PWAInstallModal
          isOpen={showModal}
          onClose={handleCloseModal}
          isIOS={isIOS}
          isAndroid={isAndroid}
          isInstallable={isInstallable}
          onInstall={handleInstall}
        />
      )}
    </>
  );
};

export default PWAInstallBanner;
